import { Link } from "react-router-dom";
import * as uuid from "uuid";

import { AppHeader } from "../components/app_header";
import { Container, Section, Title } from "../components/styled";
import { ListWithAddEditRemove } from "../components/ListWithAddEditRemove";

import { League as LeagueModel } from "../model/League";
import { useResource } from "../hooks/useResource";

export const Leagues = () => {
    const {
        data: leagues,
        loading,
        error,
        create,
        update,
        remove,
    } = useResource<LeagueModel>({
        resourceName: 'leagues',
    });

    if (loading && !leagues) {
        return (
            <Container>
                <AppHeader />
                <Section>
                    <Title data-testid="leagues-title">Leagues</Title>
                </Section>
                <Section>
                    Loading...
                </Section>
            </Container>
        );
    }

    if (error) {
        return (
            <Container>
                <AppHeader />
                <Section>
                    <Title data-testid="leagues-title">Leagues</Title>
                </Section>
                <Section>
                    Error: {error}
                </Section>
            </Container>
        );
    }

    const leagueList = leagues as LeagueModel[] || [];

    return (
        <Container>
            <AppHeader />
            <Section>
                <Title data-testid="leagues-title">Leagues</Title>
            </Section>
            <Section>
                <ListWithAddEditRemove<LeagueModel>
                    items={leagueList}
                    getKey={l => l.leagueId}
                    renderItem={l => (
                        <Link to={`/leagues/${l.leagueId}`}>{l.leagueName}</Link>
                    )}
                    resourceFormFields={[
                        {
                            name: 'leagueName',
                            label: 'League Name',
                            required: true,
                            placeholder: 'Enter league name',
                        },
                    ]}
                    onAdd={async (data) => {
                        const leagueData: LeagueModel = {
                            leagueId: uuid.v4(),
                            leagueName: data.leagueName || '',
                            seasons: [],
                        };
                        await create(leagueData);
                    }}
                    onEdit={async (id, data) => {
                        await update(id, { ...data, leagueId: id });
                    }}
                    onRemove={async (id) => {
                        await remove(id);
                    }}
                    addTitle="New League"
                    editTitle="Edit League"
                    addButtonLabel="Add +"
                    editButtonLabel="Edit"
                    submitLabel="Save"
                />
            </Section>
        </Container>
    );
};